import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { usePermissionSlice } from 'store/permission/slice';
import { PermissionApIsService, PermissionList } from 'services/openapi';
import useApi from 'services/mavapi/useApi';

export const usePermissionOperations = () => {
  const { permissionGetPermissionByRole } = PermissionApIsService;
  const dispatch = useDispatch();
  const { actions } = usePermissionSlice();
  const { handleRequest } = useApi();

  const fetchPermissions = useCallback(async () => {
    try {
      dispatch(actions.fetchPermissionsStart());
      const data = await handleRequest(permissionGetPermissionByRole());

      if (data) {
        dispatch(actions.fetchPermissionsSuccess(data));
        return data;
      }

      return null;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Failed to fetch permissions';
      dispatch(actions.fetchPermissionsFailure(errorMessage));
      console.error(error);
      return null;
    }
  }, [dispatch, actions, handleRequest]);

  const updatePermissions = useCallback(
    (permissions: PermissionList[]) => {
      dispatch(actions.updatePermissions(permissions));
    },
    [dispatch, actions],
  );

  const clearPermissions = useCallback(() => {
    dispatch(actions.clearPermissions());
  }, [dispatch, actions]);

  return {
    fetchPermissions,
    updatePermissions,
    clearPermissions,
  };
};
